import { Balkendiagramm } from "./balkendiagramm";
import { KopfLink } from "../fortschritt/kopf-link";
import { LeerZustand } from "../leerzustand";
import type { BalkenDaten } from "./balken-optionen";

/**
 * Karte mit Kopf und einem Säulendiagramm. Kopf ohne Status-Pille des Originals
 * (dort „On track“ mit Tooltip, hier ohne Datenbezug); rechts optional ein Textlink
 * (KopfLink, aus segmented-status-progress-card).
 */
export function BalkenKarte({
  id,
  titel,
  daten,
  beschriftung,
  link,
  leer,
}: {
  id: string;
  titel: string;
  daten: BalkenDaten;
  /** Leerzustand ohne Daten (keine Kategorie). */
  leer: { titel: string; text: string };
  /** Zugängliche Beschreibung des Diagramms (aria-label). */
  beschriftung: string;
  link?: { href: string; text: string };
}) {
  const titelId = `${id}-titel`;
  return (
    <>
      {/* Preline: data-display/data-display-sub-analytics-kpis/data-display-cat-bar-charts/progress-row-bar-chart-card */}
      <section aria-labelledby={titelId} className="flex flex-col bg-layer border border-layer-line shadow-xs rounded-xl">
        {/* Header */}
        <div className="py-3 px-5 border-b border-line-2">
          <div className="flex flex-wrap justify-between items-center gap-y-2 gap-x-5">
            <div>
              <h2 id={titelId} className="font-medium text-foreground">
                {titel}
              </h2>
            </div>
            {link && <KopfLink href={link.href} text={link.text} />}
          </div>
        </div>
        {/* End Header */}

        {/* Body */}
        <div className="py-4 px-5">
          {daten.werte.length === 0 ? (
            <LeerZustand titel={leer.titel} text={leer.text} />
          ) : (
            <Balkendiagramm id={`${id}-diagramm`} daten={daten} beschriftung={beschriftung} />
          )}
        </div>
        {/* End Body */}
      </section>
    </>
  );
}
